import React, { useEffect, useState } from "react";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import {
  GetPatientDetails,
  PatientPersonalInfo,
  PatientWfHistory,
} from "patients-experience-client";
import { EditPathway } from "./EditPathway";
import OffCanvas from "../../../../components/offCanvas";
import Toaster, { ToastConfig } from "../../../../components/Toaster";
import { ErrorTypes } from "../../../../interfaces/errors";
import Spinner from "../../../../components/Spinner";
import { ReactComponent as EditIcon } from "../../../../assets/img/EditPatientInfo.svg";
import Accordion from "react-bootstrap/Accordion";
import { formatDateTime } from "../../../../helper/dateFormatter";
interface PathwayProps {
  patientInfo: PatientPersonalInfo | undefined;
}

export const Pathway: React.FC<PathwayProps> = (props: PathwayProps) => {
  const patientApi = createPatientApi();
  const [programPathway, setProgramPathway] = useState<GetPatientDetails>();
  const [programPathwayHistory, setProgramPathwayHistory] = useState<PatientWfHistory[]>();
  const [loading, setLoading] = useState<boolean>(true);
  const [offCanvasTitle, setOffCanvasTitle] = useState("");
  const [offCanvasShow, setOffCanvasShow] = useState(false);
  const [offCanvasComp, setOffCanvasComp] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState<ToastConfig>({
    type: "success" as ErrorTypes,
    title: "",
    icon: "",
  });

  const getProgramPathway = async () => {
    setLoading(true);
    setProgramPathway(undefined);
    try {
      const pathwayProgramResponse =
        await patientApi.patientsControllerGetPatientDetails(
          props.patientInfo!.patientId
        );
      setProgramPathway(pathwayProgramResponse.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getPatientProgramPathwayHistory = async () => {
    setLoading(true);
    setProgramPathwayHistory(undefined);
    try {
      const pathwayProgramResponse =
        await patientApi.patientsControllerGetPatientWfHistory(
          props.patientInfo!.patientId
        );
      setProgramPathwayHistory(pathwayProgramResponse.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (toasterConfig: ToastConfig) => {
    setToastConfig(toasterConfig);
    setShowToast(true);
    getProgramPathway();
    getPatientProgramPathwayHistory();
  };

  useEffect(() => {
    if (props.patientInfo) {
      getProgramPathway();
      getPatientProgramPathwayHistory();
    }
  }, [props.patientInfo]);

  const handleOffCanvasShow = (comp: string) => {
    setOffCanvasTitle("Edit Wellinks Program & Pathway");
    setOffCanvasShow(!offCanvasShow);
    setOffCanvasComp(comp);
  };
  const mostRecentDate = programPathwayHistory?.length
  ? programPathwayHistory[0]?.changedAt
  : null;
const displayDate = mostRecentDate ? formatDateTime(mostRecentDate) : "-";

  return (
    <>
      {loading && <Spinner />}
      <div className="row">
        <Toaster
          show={showToast}
          onClose={() => setShowToast(false)}
          type={toastConfig.type}
          title={toastConfig.title}
          message={toastConfig.message}
          icon={toastConfig.icon}
        />
      </div>
      <div className="d-flex align-items-center">
        <h2 className="h4 m-0">Wellinks Program &amp; Pathway</h2>
        <a
          href="#"
          className={`btn d-flex align-items-center py-1 pe-4 ms-auto`}
          onClick={() => handleOffCanvasShow("editPathway")}
        >
          <EditIcon />
          <span className="d-inline-block lh-sm ms-2 border-primary border-bottom text-secondary">
            Edit
          </span>
        </a>
      </div>
      <hr />
      <div className="row g-2">
        <div className="col-12 col-md-6 col-lg-6">
          <div className="mb-3">
            <label className="form-label text-light mb-1 fs-14">Program</label>
            <p className="fw-medium fs-14 mb-0">
              {programPathway?.program?.type
                ? programPathway?.program?.type
                : "-"}
            </p>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-6">
          <div className="mb-3">
            <label className="form-label text-light mb-1 fs-14">Pathway</label>
            <p className="fw-medium fs-14 mb-0">
              {programPathway?.pathway?.currentPathway
                ? programPathway?.pathway?.currentPathway
                : "-"}
            </p>
          </div>
        </div>
        <div className="col-12 col-md-12 col-lg-12">
          <div className="mb-3">
            <label className="form-label text-light mb-1 fs-14">Date</label>
            <p className="fw-medium fs-14 mb-0">{displayDate}</p>
          </div>
          <Accordion bsPrefix={'timeline__accordion'} defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header className="pb-1">Timeline</Accordion.Header>
              <Accordion.Body>
                <ul className="timeline">
                  {programPathwayHistory?.length ?
                    programPathwayHistory?.map((item, index) => {
                      return (
                        <li className={`timeline__item fs-13 ${!index ? 'is-active' : ''}`} key={index}>
                          <span className="d-block">
                            {item ? formatDateTime(item?.changedAt): ''}
                            {!index ? ' - Present' : ''}
                          </span>
                          <span className="timeline__highlight d-block">
                            Program: {item?.program?.name}
                          </span>
                          <span className="timeline__highlight d-block">
                            Pathway: {item?.pathway?.name}
                          </span>
                        </li>
                      );
                    }) :
                    <>
                      No data found
                    </>
                  }
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <OffCanvas
        title={offCanvasTitle}
        offCanvasShow={offCanvasShow}
        setOffCanvasShow={setOffCanvasShow}
        offCanvasComp={offCanvasComp}
      >
        {offCanvasComp === "editPathway" && (
          <EditPathway
            onSubmit={onSubmit}
            patientInfo={props.patientInfo}
            programPathway={programPathway}
            setOffCanvasShow={setOffCanvasShow}
          />
        )}
      </OffCanvas>
    </>
  );
};
